module.exports = __webpack_public_path__ + "static/media/endRight.6ed82058.svg";